import React from "react";

const ArabicText = ({ text, className = "", size = "normal" }) => {
  const sizeClass = size === "large" ? "arabic-text-large" : "arabic-text";
  
  return (
    <p className={`${sizeClass} ${className}`} dir="rtl" lang="ar">
      {text}
    </p>
  );
};

export default ArabicText;
